export enum UserRole{
  Invalid = 0,
  Administrator = 1,
  Regular = 2
}
